module.exports = __webpack_public_path__ + "img/blockshape_l.82e230f4.png";